import { VFC } from 'react';
import { Tooltip } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useInstallMeterStepsStore } from '../../components/store';
import { Button } from '../../../../components/Button/Button';
import { useStore } from '../../useStore';
import { selectIsInstallMeterPhotoStepOK } from './selectors';
import { PhotoStepFooter as messages } from './messages';

export const PhotoStepFooter: VFC = () => {
  const { setPreviousStep } = useInstallMeterStepsStore();
  const intl = useIntl();

  const isStepOK = useStore(state => selectIsInstallMeterPhotoStepOK(intl, state));

  return (
    <>
      <Button block style={{ marginRight: 15 }} onClick={() => setPreviousStep()}>
        <FormattedMessage {...messages.back} />
      </Button>

      <Tooltip placement="top" title={isStepOK ? null : intl.formatMessage(messages.tooltip)}>
        <Button key="submit" block disabled={!isStepOK} form="photoStepForm" htmlType="submit" type="primary">
          <FormattedMessage {...messages.next} />
        </Button>
      </Tooltip>
    </>
  );
};
